import { httpUtil } from './httpUtil';

const querystring = require('querystring');

let urlMWElastiCache = document._portalConfig.urlMWElastiCache;
let apiKeyMWElastiCache = document._portalConfig.apiKeyMWElastiCache;

export const mwElastiCacheServices = {
    getJWTToken,
    updateServiceRequest,
}

async function getJWTToken({
    hash_token,
} = {}) {
    try {
        const response = await get({
            resourcePath: '/token/' + hash_token,
        });
        console.log("GET response: ", response)
        let startSession = false;
        if(response.code == 'OK' && response.data && response.data.token && response.data.token.access_token){
            startSession = true;
            httpUtil.startSession(response.data.token);
        }
        console.log("GET startSession: ", startSession)
        return response;
    } catch (ex) {
        return ex;
    }
}

async function updateServiceRequest({
    service_request_id,
    custom_fields,
} = {}) {
    try {
        const response = await put({
            resourcePath: '/service_requests/' + service_request_id,
            body: {
                custom_fields: custom_fields,
            }
        });
        console.log("GET response: ", response)
        let startSession = false;
        if(response.code == 'OK' && response.data && response.data.token && response.data.token.access_token){
            startSession = true;
            httpUtil.startSession(response.data.token);
        }
        console.log("GET startSession: ", startSession)
        return response;
    } catch (ex) {
        return ex;
    }
}

function createOption() {
    var options = {};
    options.headers = {
        'User-Agent': 'request',
        'Content-Type': 'application/json; charset=utf-8',
        'x-api-key': apiKeyMWElastiCache,
    };
    return options;
}

function cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj;
}

function json2Obj(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return null;
    }
}

function getURI(resourcePath) {
   return urlMWElastiCache + resourcePath;
}

async function get({
    resourcePath,
    queryParams,
    isPaygate
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'GET';
        let uri = getURI(resourcePath, isPaygate);
        if (queryParams)
            uri = uri + '?' + querystring.encode(cleanObj(queryParams));;
        console.log("GET uri:", uri);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("AAAA e:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function post({
    resourcePath,
    body,
    isPaygate,
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'POST';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);
        console.log("POST uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("post exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}

async function put({
    resourcePath,
    body,
    isPaygate,
}) {
    try {
        var options = createOption(isPaygate);
        options.method = 'PUT';
        let uri = getURI(resourcePath, isPaygate);
        if (body)
            options.body = JSON.stringify(body);
        console.log("PUT uri:", uri);
        console.log("options:", options);
        var response = await fetch(uri, options);
        let bodyText = await response.text()
        console.log('Response - ', response.status, ' - Body:', json2Obj(bodyText));
        if (response.status == '200') {
            return { code: "OK", data: bodyText ? json2Obj(bodyText) : null };
        } else {
            return { code: response.status, bodyText: bodyText, error: json2Obj(bodyText) };
        }
    } catch (e) {
        console.log("PUT exception:", e);
        let bodyText = await e.text();
        return { code: e.status, bodyText: bodyText, error: json2Obj(bodyText) };
    }
}
